import Phaser from 'phaser';
import { Direction } from '@shared/types/entity';
import { TILE_SIZE } from '@shared/constants';

/**
 * Sprites de cabeza:
 * - 1 fila, 4 columnas (sin animación).
 * - Col 0: mira abajo
 * - Col 1: mira derecha
 * - Col 2: mira izquierda
 * - Col 3: mira arriba
 *
 * Los PNG actuales de head (`head1.png`, `head2.png`, etc.) son una tira
 * horizontal de 4 columnas x 1 fila (por ejemplo ~92x30 px), así que cada
 * frame es aproximadamente 23x30 px.
 *
 * Para que Phaser recorte bien cada dirección, usamos el tamaño REAL del frame
 * y no `TILE_SIZE` aquí.
 */
const HEAD_COLUMNS = 4;
const HEAD_FRAME_WIDTH = 23;
const HEAD_FRAME_HEIGHT = 30;

export function getHeadSpriteKey(headId: number): string {
  return `head${headId}`;
}

/**
 * IDs de cabezas que tienen asset real en `assets/entities/head/head<id>.png`.
 * Fuente de verdad de qué existe: antes se precargaba `1..100` a ciegas, lo que 404eaba
 * los ids faltantes en ese rango Y NO cargaba las cabezas 101–113 (que sí existen) →
 * esos personajes renderizaban rotos. Al agregar un `head<id>.png` nuevo, sumá su id acá.
 */
export const EXISTING_HEAD_IDS: number[] = [
  1, 2, 3, 4, 5, 11, 12, 13, 14, 15, 16, 17, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34,
  35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 81, 82, 83, 84,
  85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 101, 102, 103, 104, 105, 106, 107, 111, 112, 113,
];

export function preloadHeadSprites(scene: Phaser.Scene, headIds: number[]): void {
  for (const id of headIds) {
    const key = getHeadSpriteKey(id);
    // Asegurarnos de que el recurso sea SIEMPRE un spritesheet
    // (si antes se cargó como imagen simple, lo eliminamos primero).
    if (scene.textures.exists(key)) {
      scene.textures.remove(key);
    }

    scene.load.spritesheet(key, `assets/entities/head/${key}.png`, {
      frameWidth: HEAD_FRAME_WIDTH,
      frameHeight: HEAD_FRAME_HEIGHT,
    });
  }
}

/**
 * Devuelve el índice de frame de cabeza según la dirección.
 * 0: abajo, 1: derecha, 2: izquierda, 3: arriba.
 */
export function getHeadFrameForDirection(dir: Direction): number {
  switch (dir) {
    case Direction.DOWN:
      return 0;
    case Direction.RIGHT:
      return 1;
    case Direction.LEFT:
      return 2;
    case Direction.UP:
      return 3;
    default:
      return 0;
  }
}


